var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElsrtlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 45,
    viewBox: "0 0 144 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3496 9.08868L32.6037 5.36557L42.0798 22.3352L19.8257 26.0583L10.3496 9.08868Z",
    fill: "#0091E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3496 9.08868L32.6037 5.36557L42.0798 22.3352L19.8257 26.0583L10.3496 9.08868Z",
    fill: "url(#paint0_linear_2427_9757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8574 26.0528L42.1115 22.3297L34.5441 38.8402L12.29 42.5633L19.8574 26.0528Z",
    fill: "#0091E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8574 26.0528L42.1115 22.3297L34.5441 38.8402L12.29 42.5633L19.8574 26.0528Z",
    fill: "url(#paint1_linear_2427_9757)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89712 25.6463L10.3815 9.08281L19.8576 26.0525L12.3732 42.616L2.89712 25.6463Z",
    fill: "#0091E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89712 25.6463L10.3815 9.08281L19.8576 26.0525L12.3732 42.616L2.89712 25.6463Z",
    fill: "url(#paint2_linear_2427_9757)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89712 25.6463L10.3815 9.08281L19.8576 26.0525L12.3732 42.616L2.89712 25.6463Z",
    fill: "url(#paint3_linear_2427_9757)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9561 6.83447L23.5238 9.07883C22.0295 9.34859 21.0366 10.7788 21.3064 12.2732C21.5762 13.768 23.0064 14.7603 24.5007 14.4905L36.933 12.2462L35.9561 6.83447ZM24.4527 13.6698C23.4018 13.8595 22.3963 13.1615 22.2066 12.1107C22.1087 11.5688 22.2468 11.0394 22.5478 10.6273C22.5845 10.5774 22.6232 10.5291 22.664 10.4826C22.7159 10.4246 22.7707 10.3696 22.8287 10.3184C22.8986 10.2567 22.9732 10.1996 23.0523 10.148C23.1445 10.0882 23.242 10.0357 23.3449 9.99116C23.48 9.93333 23.6212 9.89103 23.7658 9.86505L29.2573 8.87369L29.2572 8.87321L28.9872 9.02789L33.8811 11.9678L24.4527 13.6698Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3042 12.157L37.2717 6.43757C37.2103 6.09792 36.8853 5.87234 36.5457 5.93365L36.3919 5.96141C36.0523 6.02273 35.8266 6.34772 35.8879 6.68737L36.9204 12.4067C36.9817 12.7464 37.3068 12.972 37.6464 12.9106L37.8002 12.8829C38.1398 12.8216 38.3655 12.4966 38.3042 12.157Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2427_9757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8818 11.9673L24.4534 13.6693C23.4025 13.859 22.397 13.161 22.2073 12.1102C22.1095 11.5684 22.2475 11.0389 22.5485 10.6268C22.5852 10.5769 22.6239 10.5287 22.6647 10.4821C22.7166 10.4242 22.7715 10.3691 22.8295 10.3179C22.8993 10.2562 22.9739 10.1991 23.053 10.1476C23.1452 10.0877 23.2427 10.0353 23.3456 9.9907C23.4807 9.93288 23.6219 9.89057 23.7665 9.8646L29.258 8.87324L29.2579 8.87277L29.7935 8.79578C30.0618 10.2818 33.6135 10.4812 33.8818 11.9673Z",
    fill: "#0091E1"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7654 9.86448C23.6176 9.89116 23.477 9.93376 23.3445 9.99058C23.4794 9.93239 23.6206 9.88993 23.7653 9.86405L29.2568 8.87268L29.2569 8.87316L23.7654 9.86448Z",
    fill: "url(#paint4_linear_2427_9757)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3452 9.9903C23.2423 10.0349 23.1449 10.0873 23.0526 10.1472C23.1454 10.0864 23.2433 10.0339 23.3452 9.9903Z",
    fill: "url(#paint5_linear_2427_9757)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0522 10.1473C22.9739 10.1985 22.8994 10.2553 22.8293 10.3173C22.8993 10.2552 22.9738 10.1984 23.0522 10.1473Z",
    fill: "url(#paint6_linear_2427_9757)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.959 14.4391L27.5267 16.6834C26.0324 16.9532 25.0396 18.3834 25.3093 19.8778C25.5792 21.3726 27.0093 22.3649 28.5037 22.0952L40.9359 19.8508L39.959 14.4391ZM28.4556 21.2744C27.4047 21.4641 26.3992 20.7661 26.2095 19.7153C26.1117 19.1734 26.2498 18.644 26.5508 18.2319C26.5874 18.182 26.6262 18.1337 26.667 18.0872C26.7188 18.0293 26.7737 17.9742 26.8317 17.923C26.9015 17.8613 26.9761 17.8042 27.0552 17.7526C27.1475 17.6928 27.2449 17.6404 27.3478 17.5958C27.4829 17.5379 27.6241 17.4956 27.7688 17.4697L33.2603 16.4783L33.2602 16.4778L32.9901 16.6325L37.884 19.5724L28.4556 21.2744Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3071 19.7618L41.2746 14.0424C41.2133 13.7028 40.8882 13.4772 40.5486 13.5385L40.3948 13.5663C40.0552 13.6276 39.8295 13.9526 39.8909 14.2922L40.9234 20.0116C40.9847 20.3512 41.3097 20.5768 41.6494 20.5155L41.8031 20.4877C42.1428 20.4264 42.3684 20.1015 42.3071 19.7618Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2427_9757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8842 19.5719L28.4558 21.2739C27.405 21.4637 26.3994 20.7657 26.2097 19.7148C26.1119 19.173 26.25 18.6435 26.551 18.2314C26.5876 18.1815 26.6264 18.1333 26.6672 18.0868C26.7191 18.0288 26.7739 17.9737 26.8319 17.9225C26.9017 17.8609 26.9763 17.8037 27.0554 17.7522C27.1477 17.6923 27.2452 17.6399 27.348 17.5953C27.4831 17.5375 27.6243 17.4952 27.769 17.4692L33.2604 16.4779L33.2604 16.4774L33.796 16.4004C34.0643 17.8864 37.6159 18.0858 37.8842 19.5719Z",
    fill: "#0091E1"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7688 17.4693C27.621 17.496 27.4804 17.5386 27.3479 17.5954C27.4828 17.5372 27.6241 17.4948 27.7687 17.4689L33.2603 16.4775L33.2603 16.478L27.7688 17.4693Z",
    fill: "url(#paint7_linear_2427_9757)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3481 17.5952C27.2453 17.6397 27.1478 17.6922 27.0555 17.752C27.1483 17.6913 27.2462 17.6388 27.3481 17.5952Z",
    fill: "url(#paint8_linear_2427_9757)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0552 17.7522C26.9768 17.8034 26.9023 17.8602 26.8322 17.9221C26.9022 17.86 26.9767 17.8032 27.0552 17.7522Z",
    fill: "url(#paint9_linear_2427_9757)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0894 32.5599V36.5971H49.6862V10.3007H54.5781V32.5599H65.0894ZM86.9497 15.0835C86.8042 15.3381 86.6466 15.526 86.4768 15.6473C86.3192 15.7564 86.1192 15.8109 85.8767 15.8109C85.6221 15.8109 85.3433 15.72 85.0402 15.5382C84.7492 15.3442 84.3976 15.132 83.9854 14.9017C83.5732 14.6713 83.0883 14.4652 82.5306 14.2833C81.985 14.0894 81.3364 13.9924 80.5847 13.9924C79.9058 13.9924 79.3117 14.0772 78.8025 14.247C78.2933 14.4046 77.8629 14.6289 77.5113 14.9198C77.1719 15.2108 76.9173 15.5624 76.7475 15.9746C76.5778 16.3747 76.4929 16.8172 76.4929 17.3022C76.4929 17.9205 76.6627 18.4357 77.0021 18.8479C77.3537 19.2601 77.8144 19.6117 78.3842 19.9027C78.9541 20.1937 79.6027 20.4543 80.3301 20.6847C81.0575 20.915 81.8031 21.1636 82.5669 21.4303C83.3307 21.6849 84.0763 21.988 84.8038 22.3396C85.5312 22.679 86.1798 23.1155 86.7496 23.6489C87.3194 24.1703 87.7741 24.8128 88.1136 25.5766C88.4651 26.3404 88.6409 27.2679 88.6409 28.359C88.6409 29.5471 88.4348 30.6625 88.0226 31.7052C87.6225 32.7357 87.0285 33.6389 86.2404 34.4148C85.4645 35.1786 84.5128 35.7848 83.3853 36.2334C82.2578 36.6698 80.9666 36.8881 79.5117 36.8881C78.6752 36.8881 77.8508 36.8032 77.0385 36.6335C76.2262 36.4759 75.4442 36.2455 74.6926 35.9424C73.953 35.6393 73.2559 35.2756 72.6012 34.8513C71.9465 34.427 71.3646 33.9541 70.8554 33.4328L72.2921 31.0869C72.4133 30.9171 72.5709 30.7777 72.7649 30.6686C72.9589 30.5474 73.165 30.4867 73.3832 30.4867C73.6863 30.4867 74.0136 30.614 74.3652 30.8686C74.7168 31.1111 75.1351 31.3839 75.62 31.687C76.105 31.9901 76.6687 32.2689 77.3113 32.5235C77.966 32.766 78.748 32.8872 79.6572 32.8872C81.0515 32.8872 82.1305 32.5599 82.8943 31.9052C83.6581 31.2384 84.04 30.2867 84.04 29.0501C84.04 28.359 83.8642 27.7953 83.5126 27.3588C83.1731 26.9224 82.7185 26.5586 82.1487 26.2677C81.5788 25.9646 80.9302 25.71 80.2028 25.5039C79.4754 25.2978 78.7358 25.0735 77.9842 24.831C77.2325 24.5885 76.4929 24.2976 75.7655 23.9581C75.0381 23.6186 74.3895 23.1761 73.8196 22.6305C73.2498 22.085 72.7891 21.406 72.4375 20.5938C72.0981 19.7693 71.9283 18.757 71.9283 17.5568C71.9283 16.599 72.1163 15.6655 72.4921 14.7562C72.8801 13.8469 73.4377 13.0407 74.1652 12.3375C74.8926 11.6343 75.7898 11.0705 76.8566 10.6462C77.9235 10.2219 79.148 10.0097 80.5301 10.0097C82.082 10.0097 83.5126 10.2522 84.822 10.7371C86.1313 11.2221 87.2467 11.901 88.1681 12.7739L86.9497 15.0835ZM105.22 22.8124C106.141 22.8124 106.942 22.6972 107.62 22.4669C108.312 22.2365 108.875 21.9213 109.312 21.5212C109.76 21.109 110.094 20.6241 110.312 20.0664C110.53 19.5087 110.639 18.8964 110.639 18.2296C110.639 16.896 110.197 15.8716 109.312 15.1563C108.439 14.441 107.099 14.0833 105.293 14.0833H102.165V22.8124H105.22ZM117.804 36.5971H113.385C112.549 36.5971 111.943 36.2698 111.567 35.6151L106.038 27.1951C105.832 26.8799 105.602 26.6556 105.347 26.5223C105.105 26.3889 104.741 26.3222 104.256 26.3222H102.165V36.5971H97.2729V10.3007H105.293C107.075 10.3007 108.602 10.4886 109.875 10.8644C111.161 11.2282 112.209 11.7434 113.022 12.4102C113.846 13.077 114.452 13.8772 114.84 14.8107C115.228 15.7321 115.422 16.7505 115.422 17.8659C115.422 18.7509 115.289 19.5875 115.022 20.3755C114.767 21.1636 114.392 21.8789 113.895 22.5214C113.41 23.164 112.803 23.7277 112.076 24.2127C111.361 24.6976 110.542 25.0795 109.621 25.3584C109.936 25.5402 110.227 25.7585 110.494 26.0131C110.761 26.2555 111.003 26.5465 111.221 26.886L117.804 36.5971ZM142.701 14.3197H134.772V36.5971H129.881V14.3197H121.952V10.3007H142.701V14.3197Z",
    fill: "#0091E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2427_9757",
    x: 22.1763,
    y: 8.79578,
    width: 11.7056,
    height: 5.48673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.582067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2427_9757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2427_9757",
    x: 26.1787,
    y: 16.4004,
    width: 11.7056,
    height: 5.48673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.582067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291034
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2427_9757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2427_9757",
    x1: 25.5022,
    y1: 6.55365,
    x2: 29.2253,
    y2: 28.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2427_9757",
    x1: 31.8793,
    y1: 20.5621,
    x2: 32.6738,
    y2: 45.2946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2427_9757",
    x1: 3.27998,
    y1: 10.2709,
    x2: 7.00309,
    y2: 32.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2427_9757",
    x1: 9.07793,
    y1: 9.30089,
    x2: 15.9148,
    y2: 50.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2427_9757",
    x1: 29.2613,
    y1: 8.89716,
    x2: 23.34,
    y2: 9.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2427_9757",
    x1: 23.3543,
    y1: 10.0407,
    x2: 23.0435,
    y2: 10.0968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2427_9757",
    x1: 23.0636,
    y1: 10.2102,
    x2: 22.818,
    y2: 10.2545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2427_9757",
    x1: 33.2647,
    y1: 16.502,
    x2: 27.3435,
    y2: 17.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2427_9757",
    x1: 27.3572,
    y1: 17.6455,
    x2: 27.0464,
    y2: 17.7016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2427_9757",
    x1: 27.0665,
    y1: 17.815,
    x2: 26.8209,
    y2: 17.8593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF343B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElsrtlogo);
export default __webpack_public_path__ + "static/media/elsrt+logo.4476aaf8f686e2febcd40ce8d0a9b074.svg";
export { ForwardRef as ReactComponent };